export default "__VITE_ASSET__BteCbi9q__"